import { render } from "./DeliveryProviderFormModal.vue?vue&type=template&id=0ab9a4a3&scoped=true&ts=true"
import script from "./DeliveryProviderFormModal.vue?vue&type=script&lang=ts"
export * from "./DeliveryProviderFormModal.vue?vue&type=script&lang=ts"

import "./DeliveryProviderFormModal.vue?vue&type=style&index=0&id=0ab9a4a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab9a4a3"]])

export default __exports__